/**
 * Feature flags (Codex). Runtime kill-switches so a feature can be turned off
 * without a code deploy — the worker reads the current values from KV at request
 * time, an operator (registrar) flips them in-app, and the SPA hides the entry
 * point accordingly. Defaults are **on**: a missing/unreadable flag means the
 * feature works (a config blip must never dark-out a shipped feature).
 *
 * This is the shared shape only — the worker owns the KV read/write + audit trail.
 * Adding a flag: add a field here (default its safe value), gate the feature on it
 * in the worker + web, and it appears in the registrar's admin panel automatically.
 */
export interface FeatureFlags {
  /** The History "Compare" visual-diff view (engine + button + route). */
  compare: boolean;
}

/** Safe defaults — every feature on. A flag is only ever stored to turn one OFF. */
export const FLAG_DEFAULTS: FeatureFlags = {
  compare: true,
};

/** The known flag names (drives the admin panel + validation). */
export const FLAG_NAMES = Object.keys(FLAG_DEFAULTS) as (keyof FeatureFlags)[];
